import {Component, Input, OnInit} from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';

@Component({
  selector: 'app-throughput',
  templateUrl: './throughput.component.html',
  styleUrls: ['./throughput.component.scss']
})
export class ThroughputComponent implements OnInit {
  @Input()
  index: any;

  @Input()
  store: ArrayStore;

  constructor() { }

  ngOnInit(): void {
  }

}
